import {handleValidationChange} from '../CommonValidation';

export const validateStoreDeposit = (data, setIsError) => {
    var isValid = true;

    if(data.date === "" || data.date === undefined) {
        handleValidationChange("date", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("date", false, setIsError);
    }

    if(data.zcounter_id === "" || data.zcounter_id === undefined) {
        handleValidationChange("zcounter_id", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("zcounter_id", false, setIsError);
    }

    if(data.reference_no === "" || data.reference_no === undefined) {
        handleValidationChange("reference_no", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("reference_no", false, setIsError);
    }

    if(data.deposited_to === "" || data.deposited_to === undefined) {
        handleValidationChange("deposited_to", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("deposited_to", false, setIsError);
    }


    if(data.deposited_on === "" || data.deposited_on === undefined) {
        handleValidationChange("deposited_on", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("deposited_on", false, setIsError);
    }


    if(data.deposited_by === "" || data.deposited_by === undefined) {
        handleValidationChange("deposited_by", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("deposited_by", false, setIsError);
    }


    return isValid
  
}